import { FC, useEffect, useRef, useState } from 'react'
import {
  FetchNextPageOptions,
  InfiniteQueryObserverResult,
} from '@tanstack/react-query'

import { InfiniteScroll } from '@/components/molecules/InfiniteScroll'

type EnhancedInfiniteScrollProps = {
  fetchNextPage: (
    options?: FetchNextPageOptions
  ) => Promise<InfiniteQueryObserverResult>
  isScrollDisabled: boolean
  isEnabled: boolean
}

const EnhancedInfiniteScroll: FC<EnhancedInfiniteScrollProps> = ({
  fetchNextPage,
  isScrollDisabled,
  isEnabled,
}) => {
  const targetRef = useRef<HTMLDivElement>(null)
  const [hasRendered, setHasRendered] = useState(false)

  useEffect(() => {
    if (!isEnabled) return

    const targetElement = targetRef.current

    if (targetElement) {
      const rect = targetElement.getBoundingClientRect()
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight

      if (isVisible && !hasRendered) fetchNextPage()
    }

    setHasRendered(true)
  }, [fetchNextPage, isEnabled]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="h-1" ref={targetRef} />
      <InfiniteScroll
        threshold="10%"
        disabled={isScrollDisabled}
        onRequest={fetchNextPage}
      />
    </>
  )
}

export default EnhancedInfiniteScroll
